var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.722,
    height: 41.031,
    viewBox: "0 0 29.722 41.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631",
    transform: "translate(4096.002 19482.998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_975",
    "data-name": "Rectangle 975",
    width: 18,
    height: 20,
    transform: "translate(-4089 -19478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629",
    transform: "translate(-12 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M14.861,41.031a1.339,1.339,0,0,1-.993-.443A89.829,89.829,0,0,1,6.721,31.3a55.508,55.508,0,0,1-4.634-8.221A20.988,20.988,0,0,1,0,14.855a14.861,14.861,0,0,1,29.722,0,20.989,20.989,0,0,1-2.087,8.222A55.527,55.527,0,0,1,23,31.3a90.991,90.991,0,0,1-7.143,9.289A1.362,1.362,0,0,1,14.861,41.031ZM10.2,7.18V21h5.9c2.934,0,4.757-1.463,4.757-3.819a3.2,3.2,0,0,0-3.036-3.353v-.135a2.949,2.949,0,0,0,2.5-2.969c0-2.218-1.715-3.541-4.588-3.541Zm5.3,11.429H13.124v-3.67h2.45a2.016,2.016,0,0,1,2.273,1.95C17.847,18.015,17.038,18.609,15.506,18.609Zm-.216-5.648H13.124V9.542h2.22c1.252,0,2.03.638,2.03,1.666C17.375,12.257,16.537,12.962,15.29,12.962Z",
    transform: "translate(-4084.002 -19490.998)",
    fill: "#15198f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinEnd);
export default __webpack_public_path__ + "static/media/pinEnd.7adc138807ab7748080359d1f01577c2.svg";
export { ForwardRef as ReactComponent };